import { cn } from "@/lib/utils";

const BASE =
	"pricing-summary-info-icon inline-flex shrink-0 items-center justify-center text-grey-foreground/80 transition-colors hover:text-secondary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2";

export function pricingSummaryInfoBtnClass(options?: { size?: "sm" | "md"; selfCenter?: boolean }) {
	const { size = "md", selfCenter = false } = options ?? {};
	return cn(BASE, size === "md" ? "size-5" : "size-4", selfCenter && "self-center");
}

export function pricingSummaryInfoPlaceholderClass(options?: { size?: "sm" | "md" }) {
	const { size = "md" } = options ?? {};
	return cn(
		"pricing-summary-info-icon inline-flex shrink-0 items-center justify-center text-grey-foreground/80 opacity-80",
		size === "md" ? "size-5" : "size-4",
	);
}
